<template>
    <div>
        <div class="newOne">
            <div class="content">
                <h2>这个暑假，纸搬客让环保更有意义</h2>
                <p class="p-1"><span class="span-1">纸搬客</span>2020年7月17日</p>
                <div class="details">
                    <img src="../../assets/img/newFive/1.png" alt="" class="img-2">
                    <p class="p-1 p-spe">一年一度的暑假来临了，孩子们又可以在小区畅快的玩耍了。夏日炎炎，在通州龙旺庄小区和丰台南华里小区，一些孩子时常围绕在纸搬客智能废纸回收机器周围，看着很多爷爷奶奶都在将各种废纸垃圾投入到纸搬客的机器中，孩子们也产生了浓厚的兴趣，有的甚至开始自己投放废纸垃圾。从小到两三岁的宝宝，大到十来岁的少先队员，孩子们都非常喜欢纸搬客这个大家伙。
                    </p>
                    <img src="../../assets/img/newFive/2.png" alt="" class="img-2">
                    <!-- <p class="p-1 p-spe">在“世界地球日”当天，纸搬客入驻社区-南华里社区受邀接受来自“首都财经频道”的记者采访</p> -->
                    <p class="p-1 p-spe">保护环境，从我做起，这是孩子们经常挂在嘴边的一句话，从节约用水到保护树木，孩子们总是希望可以亲身做一些切实的事情来实现保护环境的愿望。有没有一种方式可以让孩子们轻松便捷地参与其中呢？纸搬客的出现，让孩子们离实现这个愿望更近一步。纸搬客所处的小区可以说零距离和孩子们接触，不仅有利于培养孩子们养成节约资源的意识，还可以教会孩子们通过纸搬客进行有效回收，并获得的一定的环保收益用于购买学习用品，这也是很多孩子们越来越喜欢纸搬客的原因。</p>
                    <img src="../../assets/img/newFive/3.png" alt="" class="img-2">
                    <!-- <p class="p-3">（左：南华里物业经理杨玉全      右：纸搬客创始人兼CEO李嘉轩”）</p> -->
                    <p class="p-1 p-spe">我们总说，环保环境要从娃娃抓起。同样，垃圾分类也是一样。废纸垃圾作为我们日常生活中最常见的垃圾，也最容易和孩子们产生共鸣。纸搬客愿意作为教育孩子们保护环境的载体，在孩子们的成长过程中留下美好的回忆！</p>
                    <!-- <img src="../../assets/img/newFive/4.png" alt="" class="img-2"> -->
                    <!-- <p class="p-3 p-bottom">（左：纸搬客用户“陈大妈”        右：纸搬客用户“郭大爷”）</p> -->
                </div>
            </div>
            <!-- footer -->
            <footer_s></footer_s>
        </div>
    </div>
</template>
<script>
    import footer_s from '../common/footer'
    export default {
        components: {
            footer_s
        },
    }
</script>
<style scoped>
    .newOne {
        width: 100%;
        min-height: 5rem;
        position: absolute;
        background-color: #fff;
        top: 0rem;
        left: 0;
        z-index: 100;
    }
    .content{
        width: 60%;
        min-height: 4.7rem;
        margin: 0 auto;
        padding: 0 5%;
    }
    .content h2 {
        font-size: 0.13rem;
        font-family: PingFang SC;
        font-weight: bold;
        color: rgba(14, 14, 14, 1);
        line-height: 0.2rem;
        margin-top: 0.1rem;
    }
    .span-1{
        font-size: 0.06rem;
        margin-right: 0.03rem;
        color: #576b95;
    }
    .p-1 {
        font-size: 0.048rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #444;
        line-height: 0.1rem;
        margin-top: 0.03rem;
    }
    .details{
        width: 100%;
    }
    .p-2{
        font-size:0.04rem;
        font-family:PingFang SC;
        font-weight:500;
        color: #444;
        line-height:0.1rem;
        margin-bottom: 0.05rem;
    }
    .p-spe{
        text-indent: 2em;
    }
    .img-2{
        width: 100%;
        height: 100%;
        margin-top: 0.07rem;
    }
    .p-3{
        color: rgb(136, 136, 136);
        text-align: center;
        font-size: 0.04rem;
    }
    .p-bottom{
        margin-bottom: 0.3rem;
    }
</style>


// WEBPACK FOOTER //
// src/views/newChild/newFive.vue